import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-create-note-dialog',
  template: `
  <div id="im-container" class="md:p-3">
    <button mat-mini-fab class="close-button" color="primary" (click)="onNoClick()">
     <mat-icon>close</mat-icon>
    </button>
    <img class="img-fluid mat-elevation-z8" [src]="data">
  <div>
  `,
  styleUrls: ['./dialog.scss']
})
export class ShowImageDialogComponent implements OnInit {

  //data: string;

  constructor(
    public dialogRef: MatDialogRef<ShowImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
